// extracted by mini-css-extract-plugin
export default {"disclosure-font":"Disclosures_disclosure-font__z9wfn","disclosure-padding-top":"Disclosures_disclosure-padding-top__2-IO7"};